import { getAccessToken, getIdToken, processToken, isRedirectStarted } from 'app/infrastructure/auth';

export const authProvider = {
  get idToken(){return getIdToken()},
  processToken: processToken,
  get headers(){
    const token = getAccessToken();
    if (token) {
      return {
        authorization: `Bearer ${getAccessToken()}`
      };
    }
    return {};
  },
  processResponse: async (response: Response) => response,
  // Noop with standard authentication. Used by anonymous client for case password.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setAuthorization: (auth: string) => undefined,
  getAuthorization: (): string => undefined,
  get redirectStarted() { return isRedirectStarted() }
};
